 <!-- enterprise.component.html -->
<section class="hero">
    <div class="container">
        <br>
        <br>
      <h1 style="color: #fff;">Empowering Enterprises with Scalable IT & Digital Solutions</h1>
      <p>Delivering end-to-end technology solutions to help you grow and innovate.</p>
      <div class="buttons">
        <button class="primary">Get a Consultation</button>
        <button class="secondary">Explore Solutions</button>
      </div>
    </div>
  </section>
  
  <section class="offerings">
    <div class="container">
      <h2>Our Enterprise Offerings</h2>
      <div class="grid">
     <!--    <div class="card" *ngFor="let offer of offerings">
          <img [src]="offer.icon" alt="icon">
          <h3>{{ offer.title }}</h3>
          <p>{{ offer.description }}</p>
        </div> -->
      </div>
    </div>
  </section>
  
  <section class="why-us">
    <div class="container_case">
      <h2>Why Choose Us</h2>

      <div class="home-one-container">
        <div class="text-section-web">
            <h4 style="color: red; font-size: 18px;">Why Superior Digital</h4>
            <h1 style="font-size: 36px;">Future-Ready IT, Designed for Your Business Today.</h1>
        </div>
        <div class="text-section">
            <div class="text-section-inner">
                <h4>Why Superior Digital</h4>
                <h1>Future-Ready IT, Designed for Your Business Today.</h1>
            </div>
            <p class="subtext">The way we work is evolving—your IT infrastructure should evolve with it.</p>
            <p>At Superior Digital, we empower businesses with cutting-edge Apple technology and integrated solutions
                designed to scale with your vision.</p>
            <p>
                The way we work is evolving—your IT infrastructure should evolve with it.</p>
            <p>At Superior Digital, we empower businesses with cutting-edge Apple technology and integrated solutions
                designed to scale with your vision.</p>
            <p>From device deployment and mobility to AV setups, networking, and flexible financing, we make IT simple,
                smart, and seamless.</p>
            <p>Backed by strong partnerships and a team of certified experts, we deliver more than just products—we
                deliver possibilities.</p>
            <p>Let's transform the way your business works, connects, and grows—together.</p>
        </div>
    
        <div class="image-section">
            <img src="assets/images/home1.jpeg" alt="stats" class="office-image" width="70%" height="70%" />
            <div class="stats-card">
                <h3 style="color: #f4f1f1;
                font-weight: bold;
                font-size: 20px;">Helping customer across the globe</h3>
                <div class="stats-grid">
                    <div>
                        <p class="stat-number">{{customerCount}}+</p>
                        <p class="stat-number-text">Customers</p>
                    </div>
                    <div>
                        <p class="stat-number">{{partnerCount}}+</p>
                        <p class="stat-number-text">Partners</p>
                    </div>
                    <div>
                        <p class="stat-number">{{deviceCount | number:'1.0-0'}}+</p>
                        <p class="stat-number-text">Devices Deployed</p>
                    </div>
                    <div>
                        <p class="stat-number">{{projectCount}}+</p>
                        <p class="stat-number-text">Projects</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  </section>
  

  <!-- Case Studies Section (from CaseStudiesComponent) -->
  <section class="why-us">
    <div class="container">
        <div class="section-title">
        <h2>Success Stories</h2>
        <h4 style="color: red; font-size: 18px; font-weight: 400;">Have a Look at Our Work Showcase</h4>
    </div>
      <div class="home-one-container">

        <div class="tabs-container">
          <div class="pane" id="tab1">
            <div class="row case-list">
              <div class="col-lg-4 col-sm-6" *ngFor="let caseStudy of caseStudies">
                <div class="single-case">
                  <div class="case-img">
                    <a><img [src]="caseStudy.image" alt="case"/></a>
                  </div>
                  <div class="content">
                    <a><h3>{{ caseStudy.title }}</h3></a>
                    <p>{{ caseStudy.description }}</p>
                    <!-- <a class="line-bnt">Read More -&gt;</a> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="know-more-button">
        <button class="line-bnt">Know More</button>
      </div>
      </div>
    </div>
  </section>

  <section class="partners">
    <div class="container">
      <h2>Strategic Partnerships</h2>
      <div class="logos">
        <img *ngFor="let logo of partners" [src]="logo" alt="Partner logo">
      </div>
    </div>
  </section>


  <section class="enterprise-lifecycle" id="lifecycle">
    <div class="container">
      <div class="section-title">
        <h2>Enterprise Lifecycle</h2>
        <h4 style="color: red; font-size: 18px; font-weight: 400;">Comprehensive Solutions Tailored for Every Stage</h4>
      </div>
      <div class="lifecycle-diagram">
        <!-- <div class="lifecycle-center">
          <div class="center-circle">
            <span>End-End<br>Device Life-cycle<br>Management</span>
          </div>
        </div> -->
       <!--  <ng-container *ngFor="let stage of lifecycleStages; let i = index">
          <div class="lifecycle-stage" [ngStyle]="getStagePosition(i, lifecycleStages.length)">
            <div class="stage-icon">
              <img [src]="stage.icon" [alt]="stage.title + ' icon'">
            </div>
            <div class="stage-title" [style.color]="stage.color">{{ stage.title }}</div>
            <ul class="stage-bullets">
              <li *ngFor="let bullet of stage.bullets">{{ bullet }}</li>
            </ul>
          </div>
        </ng-container> -->
      </div>
    </div>
  </section>
  
  <section class="industries-we-serve">
    <div class="container">
      <div class="section-title">
        <h2>Industries We Serve</h2>
        <p>Our tailored solutions cater to a wide range of industries, ensuring that each sector receives the specialized attention it deserves.</p>
      </div>
      <div class="industries-content">
        <img src="assets/images/about-img.png" alt="Industries We Serve" class="industries-image">
        <!-- <img src="assets/images/industries/industries-we-serve.jpg" alt="Industries We Serve" class="industries-image"> -->
        <div class="industries-description">
          <ul>
            <li>Healthcare: Enhancing patient care with cutting-edge technology.</li>
            <li>Finance: Secure and efficient solutions for financial institutions.</li>
            <li>Education: Innovative tools for modern learning environments.</li>
            <li>Retail: Streamlining operations and improving customer experiences.</li>
            <li>Manufacturing: Optimizing production with smart technologies.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="partnerships-clients">
    <div class="container">
      <div class="tabs">
        <div 
          class="tab" 
          [class.active]="activeTab === 'partnerships'" 
          (click)="setActiveTab('partnerships')">
          Key Partnerships
        </div>
        <div 
          class="tab" 
          [class.active]="activeTab === 'clients'" 
          (click)="setActiveTab('clients')">
          Our Clients
        </div>
      </div>
      <div class="partnerships-content" *ngIf="activeTab === 'partnerships'">
        <div class="partnerships-info">
          <!-- <h3>Partnerships</h3> -->
          <p>
            We collaborate with industry-leading technology partners to deliver innovative, reliable, and scalable solutions for our clients' evolving business needs.
          </p>
          <a class="explore-btn" href="#">Explore more</a>
        </div>
        <div class="partnerships-logos">
          <div class="logo-row">
            <img src="assets/images/partners/samsung.png" alt="Samsung">
            <img src="assets/images/partners/apple.png" alt="Apple">
            <img src="assets/images/partners/lg.png" alt="LG">
            <img src="assets/images/partners/vivo.png" alt="Vivo">
          </div>
          <div class="logo-row">
            <img src="assets/images/partners/parablu.png" alt="Parablu">
            <img src="assets/images/partners/docusign.png" alt="DocuSign">
            <img src="assets/images/partners/cisco.png" alt="Cisco">
            <img src="assets/images/partners/42gears.png" alt="42Gears">
          </div>
          <div class="logo-row">
            <img src="assets/images/partners/freshworks.png" alt="Freshworks">
            <img src="assets/images/partners/microsoft.png" alt="Microsoft">
            <img src="assets/images/partners/hp.png" alt="HP">
            <img src="assets/images/partners/lenovo.png" alt="Lenovo">
          </div>
          <div class="logo-row">
            <img src="assets/images/partners/sennheiser.png" alt="Sennheiser">
            <img src="assets/images/partners/zoom.png" alt="Zoom">
            <img src="assets/images/partners/dellemc.png" alt="DellEMC">
            <img src="assets/images/partners/poly.png" alt="Poly">
          </div>
        </div>
      </div>
      <div class="partnerships-content" *ngIf="activeTab === 'clients'">
        <div class="partnerships-info">
          <p>
            We are proud to serve a diverse portfolio of clients, helping them achieve their business goals with innovative technology and dedicated support.
          </p>
          <a class="explore-btn" href="#">See our client stories</a>
        </div>
        <div class="partnerships-logos">
          <div class="logo-row">
            <img src="assets/images/clients/client1.png" alt="Client 1">
            <img src="assets/images/clients/client2.png" alt="Client 2">
            <img src="assets/images/clients/client3.png" alt="Client 3">
            <img src="assets/images/clients/client4.png" alt="Client 4">
          </div>
          <div class="logo-row">
            <img src="assets/images/clients/client5.png" alt="Client 5">
            <img src="assets/images/clients/client6.png" alt="Client 6">
            <img src="assets/images/clients/client7.png" alt="Client 7">
            <img src="assets/images/clients/client8.png" alt="Client 8">
          </div>
          <div class="logo-row">
            <img src="assets/images/clients/client9.png" alt="Client 9">
            <img src="assets/images/clients/client10.png" alt="Client 10">
            <img src="assets/images/clients/client11.png" alt="Client 11">
            <img src="assets/images/clients/client12.png" alt="Client 12">
          </div>
        </div>
      </div>
    </div>
</section>
